module.exports = __webpack_public_path__ + "assets/sucess-white.a5aafe648c52aae2544f9ecbbd7b032b.svg";